import script from "./lcDailogZP.vue?vue&type=script&setup=true&name=LDialog&lang=js"
export * from "./lcDailogZP.vue?vue&type=script&setup=true&name=LDialog&lang=js"

import "./lcDailogZP.vue?vue&type=style&index=0&id=6ae89894&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ae89894"]])

export default __exports__